import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { withStyles, Slide } from "@material-ui/core";
import {
  CloudUpload,
  CheckCircleOutline,
  Close,
  Check,
} from "@material-ui/icons";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { getBase64 } from "../../utils/tools";
import countriesObjects from "../../utils/countries";
import Selector2 from "../Selector2";
import {
  fetchTerritories,
  pushNotification,
  fetchCountries,
} from "../../actions/index";
import moment from "moment";
import { images } from "../../utils/images";

import OneSidedID from "./OneSidedID";
import TwoSidedID from "./TwoSidedID";

const secondaryIDcountries = ["JO", "KW", "OM", "QA", "SA", "AE"];

function AddressVerification(props) {
  const { classes, t, territories, account, countries } = props;
  const [photoUploaded, setPhotoUploaded] = useState({
    file: null,
    photoUrl: "",
  });
  const [method, setMethod] = useState(null);
  const [billType, setBillType] = useState("");
  const [billDate, setBillDate] = useState(null);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [territory, setTerritory] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [addressCountry, setAddressCountry] = useState("");
  const [missingFields, setMissingFields] = useState([]);

  const [secondaryIdType, setSecondaryIdType] = useState("");
  const [secondaryIdDate, setSecondaryIdDate] = useState(null);
  const [secondaryIdTypeOther, setSecondaryIdTypeOther] = useState("");
  const [idPhoto, setPhotos] = useState(null);
  const [restartSecId, setRestartSecId] = useState(false);

  const billTypes = [
    t("utility"),
    t("taxDoc"),
    t("creditCard"),
    t("bankStatement"),
  ];

  const secIdTypes = [
    t("passport"),
    t("identityCard"),
    t("driversLicense"),
    t("_other"),
  ];

  const inputs = [
    { input: "address1", id: "address_line_1", modifier: setAddressLine1 },
    { input: "address2", id: "address_line_2", modifier: setAddressLine2 },
    { input: "postalCode", id: "postcode", modifier: setZipcode },
    { input: "country", id: "", modifier: setAddressCountry },
    { input: "territory", id: "uniform_territory", modifier: setTerritory },
    { input: "city", id: "city", modifier: setCity },
  ];

  //// POA date
  // useEffect(() => {
  //   let now = moment();
  //   let dateOnBill = moment(billDate);

  //   let isAfter = dateOnBill.isAfter(now);

  //   if (isAfter) {
  //     props.pushNotification({
  //       message: "_invalidDateFuture",
  //       type: "error",
  //     });
  //     setBillDate(null);
  //   } else {
  //     let diff = now.diff(dateOnBill, "days");
  //     if (diff > 90) {
  //       props.pushNotification({
  //         message: "_invalidDateTooOld",
  //         type: "error",
  //       });
  //       setBillDate(null);
  //     }
  //   }
  // }, [billDate]);

  // Fetch Uniform Territories
  useEffect(() => {
    if (account.account !== null) {
      let countryFound = countriesObjects.find(
        (c) => c.alpha2 === account.account.profile.country
      );
      setAddressCountry(countryFound.name);

      props.fetchTerritories({ code: countryFound.alpha2 });
    }

    return () => {
      setRestartSecId(false);
    };
  }, []);

  useEffect(() => {
    if (countries === null) {
      props.fetchCountries();
    }
  }, [countries]);

  // Validate Expiry secondary
  // useEffect(() => {
  //   let now = moment();
  //   let expiry = moment(secondaryIdDate);

  //   let isBefore = expiry.isBefore(now);

  //   if (isBefore) {
  //     props.pushNotification({ message: "_invalidDateBefore", type: "error" });
  //     setSecondaryIdDate(null);
  //   } else {
  //     let diff = expiry.diff(now, "hours");
  //     if (diff <= 24) {
  //       props.pushNotification({
  //         message: "_invalidDateTomorrow",
  //         type: "error",
  //       });
  //       setSecondaryIdDate(null);
  //     }
  //   }
  // }, [secondaryIdDate]);

  // Handle photosAdded
  useEffect(() => {
    if (idPhoto) {
      if (secondaryIdType === "") {
        props.pushNotification({ message: "_docTypeMissing", type: "error" });
        setRestartSecId(true);
        return;
      }

      if (
        secondaryIdType.toLowerCase() === "other" &&
        secondaryIdTypeOther === ""
      ) {
        props.pushNotification({ message: "_specifyDocType", type: "error" });
        setRestartSecId(true);
        return;
      }

      if (
        secondaryIdDate === "" ||
        secondaryIdDate === null ||
        secondaryIdDate === "Invalid date"
      ) {
        setRestartSecId(true);
        props.pushNotification({
          message: "_docExpiryDateMissing",
          type: "error",
        });
        return;
      }

      let secondary_id_documents = [];

      Object.keys(idPhoto).map((i) => {
        secondary_id_documents.push({
          type:
            secondaryIdType.toLowerCase() === "other"
              ? secondaryIdTypeOther
              : secondaryIdType,
          date: secondaryIdDate,
          expiry: secondaryIdDate,
          data_uri: idPhoto[i],
        });
      });

      props.addProofOfAddress({ secondary_id_documents });
      props.moveForward(true);
    }
  }, [idPhoto]);

  // Handle Image Uplaoded
  const imageUploaded = (file) => {
    let acceptedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
    ];
    if (!acceptedTypes.includes(file.type)) {
      props.pushNotification({ message: "_invalidFileType", type: "error" });
      return;
    }

    if (file.size > 10485760) {
      props.pushNotification({ message: "_fileTooBig", type: "error" });
      return;
    }

    const photo = URL.createObjectURL(file);
    setPhotoUploaded({ photoUrl: photo, file: file });
  };

  // Create File Input Selector
  const createFileSelector = () => {
    const fileSelector = document.createElement("input");
    fileSelector.setAttribute("type", "file");
    fileSelector.addEventListener(
      "change",
      function (e) {
        imageUploaded(e.target.files[0]);
      },
      false
    );
    return fileSelector;
  };
  const fileInput = createFileSelector();

  // Browse Files
  const browseFiles = () => {
    fileInput.click();
  };

  // Handle file drop
  const handleDrop = (ev) => {
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      //   // Use DataTransferItemList interface to access the file(s)
      for (var i = 0; i < ev.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them
        if (ev.dataTransfer.items[i].kind === "file") {
          var file = ev.dataTransfer.items[i].getAsFile();
          imageUploaded(file);
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (var i = 0; i < ev.dataTransfer.files.length; i++) {
        imageUploaded(ev.dataTransfer.files[i]);
      }
    }
  };

  //////////// SUBMIT ADDRESS VERIFICATION /////////////////////
  const submitAddressVerification = async () => {
    let base64 = await getBase64(photoUploaded.file);

    let addressObj = {
      address_line_1: addressLine1,
      address_line_2: addressLine2,
      city: city,
      postcode: zipcode,
      country: addressCountry,
      uniform_territory: territory,
      proof_of_address_type: billType,
      proof_of_address_date: billDate,
      proof_of_address_document: base64,
    };

    let missingFields = [];

    Object.keys(addressObj).map((i) => {
      if (i !== "address_line_2" && addressObj[i] === "") {
        missingFields.push(i);
      }
    });

    if (missingFields.length) {
      setMissingFields(missingFields);
      return props.pushNotification({
        message: "missingFields",
        type: "error",
      });
    }

    props.addProofOfAddress(addressObj);
    props.moveForward(true);
  };

  //////////// SUBMIT SECONDARY ID /////////////////////
  const submitSecIdVerification = async () => {
    let base64 = await getBase64(photoUploaded.file);

    let secIdObj = {
      secondary_id_type:
        secondaryIdType === "Other" ? secondaryIdTypeOther : secondaryIdType,
      secondary_id_date: secondaryIdDate,
      secondary_id_document: base64,
    };

    let missingFields = [];

    Object.keys(secIdObj).map((i) => {
      if (secIdObj[i] === "") {
        missingFields.push(i);
      }
    });

    if (missingFields.length) {
      setMissingFields(missingFields);
      return props.pushNotification({
        message: "missingFields",
        type: "error",
      });
    }

    props.addProofOfAddress(secIdObj);
    props.moveForward(true);
  };

  // const handleDateChange = (date) => {
  //   let formattedDate = date.format("YYYY-MM-DD");

  //   setBillDate(formattedDate);
  // };

  // const handleSecDateChange = (date) => {
  //   let formattedDate = date.format("YYYY-MM-DD");

  //   setSecondaryIdDate(formattedDate);
  // };

  const handleDateChange = (date) => {
    if (date === null) {
      setBillDate(null);
    } else {
      let formattedDate = date.format("YYYY-MM-DD");

      console.log("DATE", formattedDate);

      if (formattedDate !== "Invalid date") {
        let now = moment();
        let dateOnBill = moment(formattedDate);

        let isAfter = dateOnBill.isAfter(now);
        let diff = now.diff(dateOnBill, "days");

        if (isAfter) {
          props.pushNotification({
            message: "_invalidDateFuture",
            type: "error",
          });
          setBillDate(null);
        } else if (diff > 90) {
          props.pushNotification({
            message: "_invalidDateTooOld",
            type: "error",
          });
          setBillDate(null);
        } else {
          setBillDate(formattedDate);
        }
      } else {
        setBillDate(formattedDate);
      }
    }
  };

  const handleSecDateChange = (date) => {
    if (date === null) {
      setSecondaryIdDate(null);
    } else {
      let formattedDate = date.format("YYYY-MM-DD");

      if (formattedDate !== "Invalid date") {
        let now = moment();
        let expiry = moment(formattedDate);

        let isBefore = expiry.isBefore(now);
        let diff = expiry.diff(now, "hours");

        if (isBefore) {
          props.pushNotification({
            message: "_invalidDateBefore",
            type: "error",
          });
          setSecondaryIdDate(null);
        } else if (diff <= 24) {
          props.pushNotification({
            message: "_invalidDateTomorrow",
            type: "error",
          });
          setSecondaryIdDate(null);
        } else {
          setSecondaryIdDate(formattedDate);
        }
      } else {
        setSecondaryIdDate(formattedDate);
      }
    }
  };

  if (countries === null) return <span />;

  if (secondaryIDcountries.includes(account.account.profile.country)) {
    return (
      <Slide in direction="left">
        <div className={classes.container}>
          <div className="stepBody">
            <div className={classes.miniTracker}>
              <h2>{t("_secondaryIdT")}</h2>
              <p>
                1<b>/2</b>
              </p>
              <p>{t("_secondaryIdP")}</p>
            </div>

            <div className="left">
              <p className="label">{t("idType")}*</p>
              <Selector2
                options={secIdTypes}
                selectorHandle={setSecondaryIdType}
                selectedOption={secondaryIdType}
                invalid={
                  missingFields.includes("secondary_id_type") ? true : false
                }
              />
              {secondaryIdType === "Other" ? (
                <p className="label">{t("specify")}</p>
              ) : (
                ""
              )}
              {secondaryIdType === "Other" ? (
                <input
                  type="text"
                  onChange={(e) => setSecondaryIdTypeOther(e.target.value)}
                  className={`textInput ${
                    missingFields.includes("source_of_funds_type")
                      ? "invalidField"
                      : ""
                  }`}
                />
              ) : (
                ""
              )}
              <p className="label">{t("documentDate")}*</p>
              {/* <input
                type="text"
                id="expiry_date_sec"
                pattern="DD-MM-YYYY"
                // value={secondaryIdDate}
                onBlur={(e) => setSecondaryIdDate(e.target.value)}
                className={`textInput ${
                  missingFields.includes("secondary_id_date")
                    ? "invalidField"
                    : ""
                }`}
              /> */}
              <KeyboardDatePicker
                value={secondaryIdDate}
                onChange={(e) => handleSecDateChange(e)}
                views={["year", "month", "date"]}
                format="YYYY/MM/DD"
                classes={{ root: classes.picker }}
                placeholder="YYYY/MM/DD"
              />

              {secondaryIdType ? (
                <div className="photoMethods">
                  <div
                    className={`btnOption ${
                      method === "camera" ? "activemethod" : ""
                    }`}
                    onClick={() => setMethod("camera")}
                  >
                    <p>{t("takePhoto")}</p>
                    {method === "camera" ? (
                      <img src={images.icons.cameraWhite} />
                    ) : (
                      <img src={images.icons.camera} />
                    )}
                  </div>
                  <div
                    className={`btnOption ${
                      method === "upload" ? "activemethod" : ""
                    }`}
                    onClick={() => setMethod("upload")}
                  >
                    <p>{t("uploadFile")}</p>
                    {method === "upload" ? (
                      <img src={images.icons.uploadWhite} />
                    ) : (
                      <img src={images.icons.upload} />
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="right" style={{ paddingBottom: 24 }}>
              {secondaryIdType === "" ? (
                ""
              ) : secondaryIdType === "Passport" ? (
                <OneSidedID
                  method={method}
                  setPhoto={setPhotos}
                  restart={restartSecId}
                />
              ) : (
                <TwoSidedID
                  method={method}
                  setPhotos={setPhotos}
                  restart={restartSecId}
                />
              )}
            </div>
          </div>
        </div>
      </Slide>
    );
  }

  return (
    <Slide in direction="left">
      <div className={classes.container}>
        <div className="stepBody">
          <div className={classes.miniTracker}>
            <h2>{t("letsVerifyAddress")}</h2>
            <p>
              1<b>/2</b>
            </p>
          </div>

          <div className="left">
            <p className="label">{t("documentType")}*</p>
            <Selector2
              options={billTypes}
              selectorHandle={setBillType}
              selectedOption={billType}
              invalid={
                missingFields.includes("proof_of_address_type") ? true : false
              }
            />
            <p className="label">{t("docDate")}*</p>
            {/* <input
              type="text"
              // value={billDate}
              id="expiry_date_bill"
              pattern="[1-31]-[1-12]-[0-9]{4}"
              onBlur={(e) => setBillDate(e.target.value)}
              className={`textInput ${
                missingFields.includes("proof_of_address_date")
                  ? "invalidField"
                  : ""
              }`}
            /> */}
            <KeyboardDatePicker
              value={billDate}
              onChange={(e) => handleDateChange(e)}
              views={["year", "month", "date"]}
              format="YYYY/MM/DD"
              classes={{ root: classes.picker }}
              placeholder="YYYY/MM/DD"
            />

            <p className="label">{t("addressDetails")}*</p>
            {inputs.map((i, idx) => {
              if (i.input === "country") {
                let countriesArr = countries.map((c) => c.name);

                return (
                  <Selector2
                    options={countriesArr}
                    selectorHandle={setAddressCountry}
                    selectedOption={addressCountry}
                    placeholder={t("country")}
                    disabled={true}
                    key={idx}
                  />
                );
              }

              if (i.input === "territory") {
                return (
                  <Selector2
                    options={territories}
                    disabled={territories.length ? false : true}
                    selectorHandle={setTerritory}
                    selectedOption={territory}
                    placeholder={t("stateProvince")}
                    key={idx}
                    invalid={
                      missingFields.includes("uniform_territory") ? true : false
                    }
                  />
                );
              }

              return (
                <input
                  key={idx}
                  type="text"
                  autoComplete="on"
                  onChange={(e) => i.modifier(e.target.value)}
                  placeholder={t(i.input)}
                  maxLength={i.id === "postcode" ? "16" : "99"}
                  className={`textInput ${
                    missingFields.includes(i.id) ? "invalidField" : ""
                  }`}
                />
              );
            })}
          </div>
          <div className="right">
            <div
              className={`dragArea ${
                photoUploaded.file !== null ? "uploadedSuccess" : ""
              }`}
              onClick={
                photoUploaded.file !== null ? () => {} : () => browseFiles()
              }
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => handleDrop(e)}
            >
              {photoUploaded.file !== null ? (
                <CheckCircleOutline
                  classes={{
                    root: classes.checkCircle,
                    paper: classes.checkCircle,
                  }}
                />
              ) : (
                <CloudUpload />
              )}
              {photoUploaded.file !== null ? (
                <>
                  <p>{t("_successUpload")}</p>
                  <p className="uploaded">
                    {t("delete")}
                    <Close
                      onClick={(e) => {
                        e.stopPropagation();
                        setPhotoUploaded({ photoUrl: "", file: null });
                      }}
                    />
                  </p>
                </>
              ) : (
                <div className={classes.dragBtn}>
                  <p>{t("dragAndDrop")}</p>
                  <h3>{t("_or")}</h3>
                  <button className={classes.uploadBtn}>
                    {t("browseFiles")}
                  </button>
                </div>
              )}
              {/* {photoUploaded.file !== null ? (
                <p className="delete">
                  {t("delete")} <Close />
                </p>
              ) : (
                ""
              )} */}
            </div>
            {photoUploaded.file !== null ? (
              <div className="submitBtn">
                <button
                  onClick={() => submitAddressVerification()}
                  className="confirmBtn"
                >
                  {t("submit")}
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </Slide>
  );
}

function mapStateToProps(state) {
  return {
    territories: state.territories,
    account: state.account,
    countries: state.countries,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchTerritories,
      pushNotification,
      fetchCountries,
    },
    dispatch
  );
}

const styles = (theme) => ({
  picker: {
    width: "100%",
    "& input": {
      paddingTop: 0,
      paddingBottom: 0,
    },
    "& .MuiInput-underline:after, & .MuiInput-underline:before": {
      borderBottomColor: "transparent",
    },
    "& .MuiOutlinedInput-root": {
      "&:hover": {
        borderColor: "transparent",
      },
    },
  },
  miniTracker: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",

    "& h2": {
      fontSize: 28,
      fontWeight: 600,
      marginBottom: 32,
      width: "90%",
    },

    "& p": {
      width: "10%",
      textAlign: "right",
      fontSize: 32,
      fontWeight: 600,
      color: theme.colors.buttons.green,
      "& b": {
        fontSize: 18,
      },

      "&:nth-of-type(2)": {
        width: "100%",
        fontSize: 16,
        color: theme.colors.text.secondary,
        textAlign: "left",
        fontWeight: 400,
        marginBottom: 32,
      },
    },
  },
  uploadBtn: {
    ...theme.defaults.roundBtn,
    background: "transparent",
    color: theme.colors.buttons.green,
    borderColor: theme.colors.buttons.green,
    fontSize: 14,
    textTransform: "capitalize",
  },
  dragBtn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& h3": {
      fontSize: 18,
      // fontFamily: "Titillium Web",
      fontWeight: 600,
      marginTop: 16,
      marginBottom: 16,
    },
  },
  checkCircle: {
    fontSize: "160px !important",
    color: theme.colors.buttons.green,
    marginBottom: 24,
  },
  container: {
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    background: theme.colors.background.fore,
    boxShadow: theme.defaults.shadow,
    maxWidth: 880,
    width: "90%",
    padding: 40,
    color: theme.colors.text.primary,

    [theme.breakpoints.down(500)]: {
      padding: 24,
    },

    "& .stepBody": {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      flexWrap: "wrap",

      "& .left": {
        width: "47.5%",
        position: "relative",

        "& .label": {
          fontSize: 16,
          // fontFamily: "Titillium Web",
          marginTop: 16,
          fontWeight: 600,

          "&:first-of-type": {
            marginBottom: 8,
            marginTop: 0,
          },
        },
        "& .selected": {
          marginTop: 8,
        },

        "& input": {
          ...theme.defaults.input,
          marginTop: 8,
          maxWidth: "none",
          "&.invalidField": {
            border: `1px solid ${theme.colors.buttons.red}`,
          },
        },

        "& .photoMethods": {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          margin: "24px auto 0",
          [theme.breakpoints.down(500)]: {
            flexDirection: "column",
          },
          "& .btnOption": {
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            transition: ".3s",
            textAlign: "center",
            justifyContent: "space-between",
            width: "47.5%",
            padding: 16,
            background: theme.colors.background.lightFore,
            "&.activemethod": {
              background: theme.colors.misc._blue,
              color: theme.colors.text.textOnRed,
            },
            [theme.breakpoints.down(500)]: {
              width: "100%",
              marginBottom: 8,
            },
            "& img": {
              width: 25,
              height: "auto",
            },

            "&:hover": {
              color: theme.colors.text.secondary,
            },
          },
        },
      },
      "& .right": {
        width: "50%",

        "& .dragArea": {
          height: "100%",
          border: `2px dashed ${theme.colors.misc.dividers}`,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: ".3s",
          position: "relative",
          padding: 16,

          "& .uploaded": {
            background: theme.colors.text.tertiary,
            borderRadius: 24,
            padding: "0 16px",
            display: "flex",
            alignItems: "center",
            height: 30,
            marginTop: 8,
            fontSize: 18,
            fontWeight: 400,
            color: theme.colors.text.textOnRed,
            "& svg": {
              fontSize: 18,
              cursor: "pointer",
            },
          },

          "& svg": {
            fontSize: 80,
          },

          "&.uploadedSuccess": {
            height: "80%",
            border: "none",
            cursor: "auto",
            "&:hover": {
              background: "none",
            },
          },
        },
        "& .submitBtn": {
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 70,
          "& .confirmBtn": {
            ...theme.defaults.roundBtn,
            background: theme.colors.buttons.green,
          },
        },
        "& .cameraButtons": {
          display: "flex",
          justifyContent: "center",
          marginTop: 12,
          "& .photoBtnWrapper": {
            height: 38,
            width: 38,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            border: `2px solid ${theme.colors.buttons.blue}`,
            "& .takePhotoBtn": {
              height: 32,
              width: 32,
              borderRadius: "50%",
              background: theme.colors.buttons.blue,
              cursor: "pointer",
              transition: ".3s",
              "&:hover": {
                opacity: 0.3,
              },
            },
          },
          "& .takenBtnWrapper": {
            width: "75%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            "& button": {
              ...theme.defaults.roundBtn,
              color: theme.colors.misc.black,
            },
            "& .confirmBtn": {
              background: theme.colors.buttons.green,
              color: theme.colors.text.primary,
            },
          },
        },
      },
      [theme.breakpoints.down(800)]: {
        flexDirection: "column",
        "& .left, & .right": {
          width: "100%",
        },
        "& .right": {
          order: 2,
          marginTop: 0,
          marginBottom: 24,
        },
        "& .left": {
          order: 3,
        },
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(AddressVerification)
  )
);
